import jQuery from 'jquery';
import matchHeight from 'jquery-match-height';

(($) => {
  $('.eqHeight').matchHeight();
})(jQuery);
